import { ChevronDownIcon, ProfileIcon } from '../../../../../../../assets/icons';
import { ExaminerProfile } from '../../../../../../../store/workspace/types';
import { examStatusTitle } from '../../../../../../../utils/generalHelpers';
import CheckBox from '../../../../../../../components/CheckBox';
import { ForwardedRef, forwardRef, MouseEvent } from 'react';
import { useApplicantSelection } from '../../../../hooks/useApplicantSelection';
import { useExpandableRows } from '../../../../hooks/useExpandableRows';
import { useExaminerProfile } from '../../../../hooks/useExaminerProfile';
import styles from './style.module.scss';

interface Props {
    examinersData: ExaminerProfile[];
    jobId: string | undefined;
};

const InterviewTable = forwardRef((props: Props, ref: ForwardedRef<HTMLDivElement>) => {
    const { examinersData, jobId } = props;

    const openExaminerProfile = useExaminerProfile(jobId);
    const { isExpanded, toggleRow } = useExpandableRows<string>();
    const { isSelected, toggleApplicant, toggleAll, allSelected } = useApplicantSelection(examinersData);

    const showProfile = (event: MouseEvent<HTMLTableCellElement>, examinerId: string) => {
        event.stopPropagation();
        openExaminerProfile(examinerId);
    };

    return (
        <div className={styles.container}>
            <div className={styles.table} ref={ref}>
                <table>
                    <thead>
                        <tr>
                            <th colSpan={6}>
                                <div className={styles.select_all}>
                                    <CheckBox onClick={toggleAll} checked={allSelected} />
                                    <span>Select All ({examinersData.length})</span>
                                </div>
                            </th>
                        </tr>
                        <tr>
                            <th>#</th>
                            <th>Name</th>
                            <th>Status</th>
                            <th>Email</th>
                            <th>Phone Number</th>
                            <th>Location</th>
                            <th data-noprint='true'>Info</th>
                        </tr>
                    </thead>
                    <tbody>
                        {examinersData.length > 0
                            ? examinersData.map((applicant, index) => <tr key={applicant.userId}>
                                <td>{index + 1}</td>
                                <td>
                                    <div className={styles.examinerName}>
                                        <CheckBox
                                            onClick={() => toggleApplicant(applicant.userId)}
                                            checked={isSelected(applicant.userId)}
                                        />
                                        <span> {applicant.first_name} {applicant.family_name}</span>
                                    </div>
                                </td>
                                <td>
                                    <span className={styles.status} data-status={applicant.status}>
                                        {examStatusTitle(applicant.status)}
                                    </span>
                                </td>
                                <td>{applicant.email}</td>
                                <td>{applicant.phone_number}</td>
                                <td>{applicant.city} / {applicant.state}</td>
                                <td data-noprint='true' onClick={event => showProfile(event, applicant.userId)}>
                                    <ProfileIcon />
                                </td>
                            </tr>)
                            : <tr><td colSpan={6}>No data.</td></tr>}
                    </tbody>
                </table>
            </div>

            <div className={styles.mobile_list}>
                {examinersData.map(applicant => <div className={styles.card} key={applicant.userId}>
                    <div className={styles.card_header} onClick={() => toggleRow(applicant.userId)}>
                        <span>{applicant.first_name} {applicant.family_name}</span>
                        <ChevronDownIcon style={{ transform: isExpanded(applicant.userId) ? 'rotate(180deg)' : 'none' }} />
                    </div>

                    {isExpanded(applicant.userId) && <div className={styles.card_body}>
                        <div className={styles.card_body_section}>
                            <div className={styles.card_body_section_title}>
                                <span>Status</span>
                                <span className={styles.status} data-status={applicant.status}>
                                    {examStatusTitle(applicant.status)}
                                </span>
                            </div>
                        </div>
                        <div className={styles.card_body_section}>
                            <div className={styles.card_body_section_title}>
                                <span>Email</span>
                                <span>{applicant.email}</span>
                            </div>
                        </div>
                        <div className={styles.card_body_section}>
                            <div className={styles.card_body_section_title}>
                                <span>Phone Number</span>
                                <span>{applicant.phone_number}</span>
                            </div>
                        </div>
                        <div className={styles.card_body_section}>
                            <div className={styles.card_body_section_title}>
                                <span>Location</span>
                                <span>{applicant.city} / {applicant.state}</span>
                            </div>
                        </div>
                    </div>}
                </div>)}
            </div>
        </div>
    );
});

export default InterviewTable;
